/**
 * SEO Constants - Single Source of Truth
 * Used by:
 * 1. src/components/SEO/index.js (Dynamic Meta Tags)
 * 2. public/index.html (Static Meta Tags - manually synced)
 */
export const SEO_CONFIG = {
    defaultTitle: "SkillBack - Your Unfair Advantage in Tech Hiring",
    defaultDescription: "Stop getting overlooked by recruiters. Build resumes that showcase your real impact in tech. Made for developers, engineers, and technical leaders. Land the interviews you deserve.",
    defaultKeywords: "tech resume, unfair advantage, recruiter-approved resume, software engineer resume, developer resume, engineering resume, tech hiring, interview success, career advancement",
    siteUrl: "https://skillback.io",
    twitterHandle: "@SkillBack", // If you have one, or generic
};
